import { ToastService } from 'src/app/services/toast.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from  '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/services/theme.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login-recover-passwd-cs',
    templateUrl: './login-recover-passwd-cs.component.html',
    styleUrls: ['./login-recover-passwd-cs.component.scss'],
    standalone: false
})
export class LoginRecoverPasswdCSComponent implements OnInit, OnDestroy {
  cardForm: UntypedFormGroup;
  ecomerceconcode: string;
  base64Logo: any;
  hasCompanyLogo = false;  // true si la URL trajo logo propio de la empresa (white-label)
  submitted = false;
  isLoading = false;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private toast: ToastService,
    private userService: UserService,
    private translate: TranslateService,
    public ThemeService: ThemeService,
    private appConfigService: AppConfigService,
    private MapInformationService: MapInformationService,
    private meta: Meta) {
    this.cardForm = fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  ngOnDestroy() {
    this.meta.removeTag("name='robots'");
  }

  ngOnInit() {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    this.ThemeService.setNavaBar('navbar-disabled');
    // el logo lo deja cargado /login; si se entra directo a esta ruta viene vacio (antes se veia
    // la imagen rota) => se usa la marca de CUBE
    const logo = this.ThemeService.getImgLogo();
    this.hasCompanyLogo = typeof logo === 'string' && logo.startsWith('data:');
    this.base64Logo = this.hasCompanyLogo ? logo : 'assets/cube-logo.png';

    // Mirror exactly what login does: dev mode gets a fixed code,
    // production resolves it from the URL via GetCompanySettings.
    if (this.appConfigService.env_dev !== undefined &&
        this.appConfigService.env_dev !== null &&
        this.appConfigService.env_dev === true) {
      this.ecomerceconcode = '02978EBB5E';
      return;
    }

    // If the user navigated through the login page, the code is already cached.
    const cached = this.ThemeService.getEcomerceconcode();
    if (cached) {
      this.ecomerceconcode = cached;
      return;
    }

    // User landed directly on this page — resolve the company code from the URL.
    const parts = this.getCurrentUrl();
    if (!environment.production) {
      console.log("🚀 ~ LoginRecoverPasswdCSComponent ~ ngOnInit ~ parts:", parts);
    }
    const info = {
      method: 'Get_CompanyCodeFromURL',
      connectioncode: 'cube',
      url: parts[0],
    };

    // Only resolve the ConnCode — logo is exclusively set by login-cubeshop.component.
    this.MapInformationService.GetCompanySettings(info).subscribe(resp => {
      if (resp && resp[0]) {
        this.ecomerceconcode = resp[0].companycode;
        this.ThemeService.setEcomerceconcode(this.ecomerceconcode);
      }
    }, () => {});
  }

  getCurrentUrl(): string[] {
    // Use hostname (no port, no path) so split('.') always gives clean parts.
    // e.g. "sfc.cube-usa.com" → ["sfc", "cube-usa", "com"] → parts[0] = "sfc"
    // e.g. "localhost"        → ["localhost"]               → parts[0] = "localhost"
    return window.location.hostname.split('.');
  }

  resetPass() {
    // validacion en cliente + estado de carga en el boton (antes el boton quedaba deshabilitado
    // sin decir por que)
    this.submitted = true;
    if (this.cardForm.invalid) {
      return;
    }
    this.isLoading = true;
    const value = this.cardForm.value;
    this.userService.recoverPassword(value.email, this.ecomerceconcode).subscribe(result => {
      this.isLoading = false;
      if (result.response == 1) {
        this.toast.success(this.translate.instant('msgRecPassSucc'));
        this.router.navigateByUrl('/login');
      } else {
        this.toast.error('An error has ocurred or Email is not valid');
      }
    }, () => {
      this.isLoading = false;
      this.toast.error('An error has ocurred or Email is not valid');
    });
  }

}
